import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Offer } from '../../interfaces/offers.interface';
import { Partner } from '../../interfaces/partners.interface';
import { OffersService } from '../../services/offers.service';
import { PartnersService } from '../../services/partners.service';
import { environment } from '../../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { CommonsService } from '../../services/common.service';

@Component({
  selector: 'app-offer-details',
  standalone: false,
  templateUrl: './offer-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./offer-details.component.scss']
})
export class OfferDetailsComponent implements OnInit {
  @Input() id?: number;
  offer?: Offer;
  partner?: Partner;
  imagesUrl = `${environment.ImagesUrl}/offer/`;

  constructor(
    private offersService: OffersService,
    private partnersService: PartnersService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private metaService: Meta, 
    private location: Location, 
    private commonsService: CommonsService
  ) {}

  
  getTimeAgo(created: string): string {
    return this.commonsService.getTimeAgo(created);

  }

  leftTime(validDate: string): string {
    if (validDate < new Date().toISOString()) {
      return 'Oferta wygasła';
    }
    return 'Zostało: ' + this.commonsService.getTimeAgo(validDate);
  } 

  ngOnInit(): void {
    // Prefer input id, fallback to route param
    if (this.id) {
      this.fetchOffer(this.id);
    } else {
      this.route.paramMap.subscribe(params => {
        const routeId = params.get('id');
        if (routeId) {
          this.fetchOffer(+routeId);
        }
      });
    }
  }

  fetchOffer(id: number) {
    this.offersService.getData(id).subscribe({
      next: (data) => {
        this.offer = data;
        
        // Load partner data if partner_id exists
        if (data.partner_id) {
          this.loadPartner(data.partner_id);
        }

        this.titleService.setTitle('Zgrane Grono - oferta -' + data.title);
        if (data.seo_desc) {
          this.metaService.updateTag({ name: 'description', content: data.seo_desc });
        }
      },
      error: () => this.offer = undefined,
    });
  }

  loadPartner(partnerId: number) {
    this.partnersService.getPartner(partnerId).subscribe({
      next: (partner) => {
        this.partner = partner;
      },
      error: (error) => {
        console.error('Error loading partner:', error);
        this.partner = undefined;
      }
    });
  }

  goToPartnerDetails(id: number, name: string) {
    this.router.navigate(['/partner', id]);
  }

    goBack() {
    this.location.back();
  }
}